import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from '../../../constants/actionTypes';
import PropTypes from 'prop-types'
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import InputText from '../../Common/InputText';
import './EditGoalGroupDrawer.scss';
import Notification from '../../Common/Notification';

export class EditGoalGroupDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false,
            isFormValid: true,
            goals: JSON.parse(JSON.stringify(props.goalGroup.goals))
        }
    }

    onFormChange = (event) => {
        // break apart the name to figure out which goal the change belongs to - then update only that object

        const peices = event.target.name.split("_");
        const goalId = parseInt(peices[0]);
        const goalIndex = this.state.goals.findIndex(m => m.goalId === goalId);

        let updatedGoals = this.state.goals.slice();
        updatedGoals[goalIndex][peices[1]] = parseInt(event.target.value);

        this.setState({ goals: updatedGoals });
    }

    validateForm = () => {
        if(!this.state.goals || this.state.goals.length <= 0){
            return false;
        } else {
            for(let goal of this.state.goals){
                if(!goal.totalValue){
                    return false;
                }
            }
        }
        return true;
    }

    onSaveClick = async () => {
        if(this.validateForm()){
            this.setState({ isLoading: true });
            try {
                const params = {
                    goalGroupId: this.props.goalGroup.id,
                    goals: this.state.goals,
                    locationKey: this.props.locationKey
                };
                const response = await this.props.locationDashboardActions.saveLocationGoals(params);
                if (response.type === types.SAVE_LOCATION_GOALS_SUCCESS) {
                    Notification("success", "Goals Updated and Saved", "");
                    this.props.onComplete();
                } else if (response.type === types.SAVE_LOCATION_GOALS_FAILURE) {
                    Notification("error", "Error", response.payload.message);
                }
            } catch (error) {
                Notification("error", "Error", error);
            } finally {
                this.setState({ isLoading: false });
            }            
        } else {
            this.setState({ isFormValid: false });
        }
    }


    render() {

        return (
            <Drawer isWide={false} title='Edit Goal Group' onSaveClick={this.onSaveClick} saveText='Save' onCancelClick={this.props.onCancel}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="edit-goal-group-drawer">
                        <div className="group-name">{this.props.goalGroup.name}</div>                    
                    </div>
                    {this.state.goals && this.state.goals.length > 0 &&
                        <form noValidate className={this.state.isFormValid ? "" : "was-validated"}>
                            {this.state.goals.map(goal => {
                                return (
                                    <div key={goal.goalId}>
                                        <div className="mb-3"><strong>{goal.name}</strong></div>
                                        <div>
                                            <InputText 
                                                name={goal.goalId + "_totalValue"} 
                                                label="Goal Total" 
                                                type="number" 
                                                maxLength={10}
                                                value={(goal.totalValue || goal.totalValue === 0) ? goal.totalValue.toString() : ""}
                                                onChange={this.onFormChange}
                                                isRequired={true}
                                                minValue={1}
                                                errorMessage="Total is Required" />
                                            <InputText 
                                                name={goal.goalId + "_darkGreenValue"} 
                                                label={goal.darkGreenName} 
                                                type="number" 
                                                maxLength={10}
                                                value={(goal.darkGreenValue || goal.darkGreenValue === 0) ? goal.darkGreenValue.toString() : ""}
                                                onChange={this.onFormChange} />
                                            <InputText 
                                                name={goal.goalId + "_mediumGreenValue"} 
                                                label={goal.mediumGreenName} 
                                                type="number" 
                                                maxLength={10}
                                                value={(goal.mediumGreenValue || goal.mediumGreenValue === 0) ? goal.mediumGreenValue.toString() : ""}
                                                onChange={this.onFormChange} />
                                            <InputText 
                                                name={goal.goalId + "_lightGreenValue"} 
                                                label={goal.lightGreenName} 
                                                type="number" 
                                                maxLength={10} 
                                                value={(goal.lightGreenValue || goal.lightGreenValue === 0) ? goal.lightGreenValue.toString() : ""}
                                                onChange={this.onFormChange} />
                                        </div>
                                    </div>                                    
                                )
                            })}
                        </form>
                    }
                </LoadingIndicator>
            </Drawer>            
        )
    }
}

EditGoalGroupDrawer.propTypes = {
    locationDashboardActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    locationKey: PropTypes.string.isRequired,
    goalGroup: PropTypes.object.isRequired
};


export default connect(null, null)(EditGoalGroupDrawer);